export enum OriginEnum {
  CSP = 1,
  Bank
}

export namespace OriginEnum {
  export function values() {
    return Object.keys(OriginEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
